import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Image } from "@/components/Image";

import { IDescriptionSection } from "./types";

type IProps = IDescriptionSection & JSX.IntrinsicElements["div"];

export const DescriptionSection: React.FC<IProps> = ({ elements, ...rest }) => {
  const { css } = useFela();
  const { bp, colors } = useTheme();

  return (
    <Grid
      id="DescriptionSection"
      customStyle={{
        position: "relative",
        flexDirection: "column",
      }}
      {...rest}
    >
      {elements.map(elem => (
        <div
          key={elem.title}
          className={css({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 40,
            [bp.FROM_TABLET]: {
              marginBottom: 0,
            },
            [bp.FROM_DESKTOP]: {
              flexDirection: elem.reverse ? "row-reverse" : "row",
              justifyContent: "space-between",
              marginTop: 42,
            },
          })}
        >
          <div
            className={css({
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flex: 2,
              [bp.FROM_DESKTOP]: {
                paddingTop: 10,
                alignSelf: "stretch",
                justifyContent: "flex-start",
              },
              [bp.FROM_LARGE_DESKTOP]: {
                alignItems: "flex-start",
                paddingLeft: 50,
              },
            })}
          >
            <span
              className={css({
                fontSize: 24,
                color: colors.DARK_GREY,
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: 20,
                [bp.FROM_DESKTOP]: {
                  fontSize: 36,
                  lineHeight: "46px",
                  textAlign: "left",
                },
              })}
            >
              {elem.title}
            </span>
            {elem.texts.map(text => (
              <p
                key={text}
                className={css({
                  fontSize: 14,
                  color: colors.GRAY,
                  textAlign: "center",
                  maxWidth: "80%",
                  marginBottom: 15,
                  [bp.FROM_DESKTOP]: {
                    fontSize: 16,
                    textAlign: "left",
                    maxWidth: "100%",
                    lineHeight: "26px",
                  },
                })}
              >
                {text}
              </p>
            ))}
          </div>

          <div
            className={css({
              width: "100%",
              display: "flex",
              justifyContent: "center",
              flex: 3,
              padding: 20,
              background: "transparent",
            })}
          >
            <Image
              src={elem.image}
              alt={elem.title}
              customStyle={{
                width: "100%",
                maxWidth: 578,
                marginBottom: 50,
                boxShadow: "20px 20px 80px 0 rgb(16 5 48 / 18%)",
                [bp.FROM_DESKTOP]: {
                  marginBottom: 0,
                },
              }}
            />
          </div>
        </div>
      ))}
    </Grid>
  );
};
